import { Modal } from '@components/Modal';
import { Button, Stack, Typography } from '@mui/material';
import { IBulkOrderBody, selectionsApiSlice } from '@src/api';
import { log } from '@src/utils';
import { FC } from 'react';

type ConfirmOrdersCreateProps = {
  ordersData: Nullable<{ data: IBulkOrderBody; id: number }>;
  onCancel: () => void;
};
export const ConfirmOrdersCreate: FC<ConfirmOrdersCreateProps> = ({ ordersData, onCancel }) => {
  if (!ordersData) return null;
  const [createBulkOrder] = selectionsApiSlice.useLazyCreateBulkOrderQuery();
  const onApply = () => {
    createBulkOrder(ordersData)
      .then(res => {
        if (res.isSuccess) return onCancel();
        return null;
      })
      .catch(log);
  };
  return (
    <Modal open={!!ordersData} title="Create orders" onCancel={onCancel}>
      <Typography color="grey.700" variant="body16Medium" lineHeight="24px">
        You are starting the process of creating multiple draft orders. This may take some time. You will be notified
        when it is complete.
      </Typography>
      <Stack direction="row" justifyContent="end" mt="36px">
        <Button variant="contained" color="secondary" onClick={onApply}>
          Ok
        </Button>
      </Stack>
    </Modal>
  );
};
